import React, { useEffect, useState } from "react";
import { DashLine } from "../../../../../styles/orderform.tsx";

function VerticalLine() {
  const container = React.useRef<HTMLDivElement>(null);

  const [containerHeight, setContainerHeight] = useState(0);

  useEffect(() => {
    const handleResize = () => {
      if (container.current) {
        setContainerHeight(container.current.clientHeight);
      }
    }
    window.addEventListener('resize', handleResize);
    handleResize();
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <DashLine direction="vertical" ref={container}>
      <svg xmlns="http://www.w3.org/2000/svg" width="2" height={containerHeight} viewBox={`0 0 2 ${containerHeight}`} fill="none">
        <path d={`M1 0L1.00001 ${containerHeight}`} stroke="#979C9E" strokeDasharray="4 4" />
      </svg>
    </DashLine>
  )
}

export default VerticalLine;
